// extracted by mini-css-extract-plugin
module.exports = {"panel":"tMxX0","modal":"_1A17R"};